import { render, staticRenderFns } from "./RegistrationHome.vue?vue&type=template&id=8b7c9a3e&scoped=true&"
import script from "./RegistrationHome.vue?vue&type=script&lang=js&"
export * from "./RegistrationHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c9a3e",
  null
  
)

export default component.exports